/*
 * Stallergenes Greer — verbindet die Prototyp-Produktseiten mit dem
 * echten Shopify-Warenkorb.
 *
 * WARUM ES DIESE DATEI GIBT:
 * Der Prototyp führt einen Schein-Warenkorb. Der ist pro Seite eigen und hat
 * genau EINEN Platz je Produktart (`var CART={matratze:null}`). Folgen im
 * Shop: was man auf einer anderen Seite gewählt hat, taucht nicht auf, ein
 * zweiter Artikel überschreibt den ersten, und nach dem Neuladen ist alles
 * weg. Zum Abnehmen des Designs war das richtig, zum Verkaufen nicht.
 *
 * Das Aussehen ist abgenommen und bleibt darum unangetastet. Dieses Skript
 * hängt sich NACH dem Seitenskript ein und ersetzt nur das Innenleben:
 *
 *   addMatratze / addKissen / ...  -> legt die Variante in Shopifys Korb
 *   renderCart                     -> zeichnet den Korb aus /cart.js
 *   removeItem                     -> entfernt die Zeile über /cart/change.js
 *   "Zur Kasse"                    -> führt zur echten Kasse
 *
 * Für die Zeilen wird die itemRow-Funktion der Seite weiterbenutzt — so
 * bleibt das Markup exakt das abgenommene.
 */
(function () {
  'use strict';

  function daten() { return window.SG_VARIANTEN || {}; }
  function eintraege() { return daten().eintraege || {}; }

  /* Der Korb erscheint auf JEDER Seite, also auch auf den franzoesischen.
     Die Beschriftungen standen vorher fest auf Deutsch - im franzoesischen
     Shop haette der Korb "Zwischensumme" und "Zur Kasse" angezeigt. */
  function sprache() {
    return (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);
  }

  /* Die Kasse braucht dasselbe Sprach-Praefix wie die Seite. Ohne das
     landet ein franzoesischer Besucher in der deutschen Kasse. */
  function wurzel() {
    return sprache() === 'de' ? '' : '/' + sprache();
  }

  var TEXTE = {
    de: { leer: 'Ihr Warenkorb ist noch leer.', summe: 'Zwischensumme',
          kasse: 'Zur Kasse', weiter: 'Weiter einkaufen', linie: 'Linie ',
          ergaenzen: 'Komplettieren Sie Ihr Bett:', gratis: 'gratis dazu',
          ab: 'ab ', groesse: 'Grösse wählen →', entfernen: 'entfernen',
          weniger: 'Menge verringern', mehr: 'Menge erhöhen',
          fehler: 'Der Artikel konnte nicht in den Warenkorb gelegt werden. '
                + 'Bitte versuchen Sie es erneut.' },
    fr: { leer: 'Votre panier est encore vide.', summe: 'Sous-total',
          kasse: 'Passer à la caisse', weiter: 'Continuer mes achats',
          linie: 'Gamme ', ergaenzen: 'Complétez votre lit :',
          gratis: 'offerte', ab: 'dès ', groesse: 'Choisir la taille →',
          entfernen: 'retirer',
          weniger: 'Diminuer la quantité', mehr: 'Augmenter la quantité',
          fehler: "L'article n'a pas pu être ajouté au panier. "
                + 'Veuillez réessayer.' }
  };

  function t(schluessel) {
    return (TEXTE[sprache()] || TEXTE.de)[schluessel];
  }

  /* Der Prototyp führt Linien als Kürzel, Shopify als Anzeigename. */
  var LINIE = {
    lal: 'LAL Supreme Plus',
    comfort: 'ACb Comfort',
    cotton: 'ACb Cotton Performance'
  };
  var KUERZEL = { 'LAL Supreme Plus': 'lal', 'ACb Comfort': 'comfort',
                  'ACb Cotton Performance': 'cotton' };

  function variante(linie, groesse) {
    var e = eintraege();
    var k = (LINIE[linie] || linie) + '|' + String(groesse).replace(/x/g, '×');
    /* Produkte mit nur EINER Option (z.B. Schlafsack: nur Grösse, keine
       Linie) erzeugen den Schluessel "85×224|" - ohne Linie davor. Ohne
       diesen Rueckfall faende die Suche nichts, gewaehlteGroesse() liefe
       ins Leere und der Kaufen-Knopf taete stumm nichts. */
    var einzeln = String(groesse).replace(/x/g, '×') + '|';
    return e[k] || e[k.replace(/×/g, 'x')]
        || e[einzeln] || e[einzeln.replace(/×/g, 'x')] || null;
  }

  /* Die Auswahl aus dem DOM lesen, NICHT aus window.
     Der Prototyp haelt sie in `let curLine, curSize`. Mit let deklarierte
     Werte landen nicht auf dem window-Objekt - window.curSize war immer
     undefined, und es wanderte stets dieselbe Variante in den Korb. Genau
     das sah aus wie "ich kann nur ein Produkt hinzufuegen".
     Die Markierung im DOM ist dagegen eindeutig und ueberlebt jede
     Umbenennung im Seitenskript. */
  function gewaehlteLinie() {
    var el = document.querySelector('.line-opt.sel');
    return (el && el.dataset && el.dataset.line) || 'comfort';
  }

  function gewaehlteGroesse() {
    var el = document.querySelector('.size-opt.sel');
    if (el) return (el.textContent || '').trim();
    return daten().einzelgroesse || null;   // Reisebezug: nur eine Groesse
  }

  function preisText(rappen) {
    var v = rappen / 100;
    if (typeof window.fmt === 'function') return window.fmt(v);
    return 'CHF ' + v.toFixed(2);
  }

  function fetchJSON(pfad, optionen) {
    return fetch(pfad, optionen).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || r.status);
        return d;
      });
    });
  }

  var korb = null;

  /* Die Warenkorb-Adressen MUESSEN die Sprachwurzel tragen. Shopify liefert
     unter /cart.js die Produkttitel in der Standardsprache - auf der
     franzoesischen Seite standen dadurch alle Artikel im Korb auf Deutsch.
     Erst /fr/cart.js liefert die uebersetzten Titel. Betrifft Lesen,
     Hinzufuegen und Aendern gleichermassen. */
  function korbLesen() {
    return fetchJSON(wurzel() + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (k) { korb = k; return k; });
  }

  /* ---------------------------------------------------------------
     Anzeige — Markup identisch zum Prototyp, Inhalt aus dem echten Korb
     --------------------------------------------------------------- */

  /* Der Zaehler am Warenkorb-Symbol.
     Steht bewusst FUER SICH und nicht in zeichnen(): Er haengt am Kopf und
     muss auf jeder Seite stimmen - auch dort, wo es keine Schublade und
     keine Varianten gibt (Startseite, FAQ, Rechtstexte). */
  function zaehlerSetzen() {
    var badge = document.getElementById('cart-badge');
    if (!badge || !korb) return;
    badge.textContent = korb.item_count;
    badge.style.display = korb.item_count > 0 ? '' : 'none';
  }

  /* Vom Shopify-Produkt zurueck auf UNSERE Produktseite.
     Shopifys eigener Pfad (/products/handle) wuerde Dawns Standardvorlage
     zeigen - eine Seite, die mit dem abgenommenen Design nichts zu tun hat.
     Darum die feste Zuordnung auf die Seiten des Prototyps. */
  /* Zuordnung Shopify-Produkt -> unsere Produktseite. Sie kommt aus dem
     Kopf-Skript (window.SG_PRODUKTSEITE), weil sg-suche.js dieselbe braucht.
     Shopifys eigener Pfad /products/<handle> wuerde Dawns Standardvorlage
     zeigen - eine Seite, die mit dem abgenommenen Design nichts zu tun hat. */
  function produktLink(handle) {
    var m = window.SG_PRODUKTSEITE || {};
    var tabelle = m[sprache()] || m.de || {};
    return tabelle[handle] || null;
  }

  function mengensteller(nr, menge) {
    var knopf = function (richtung, zeichen, titel) {
      return '<button type="button" onclick="sgMenge(\'' + nr + '\',' + richtung + ')" '
        + 'aria-label="' + titel + '" class="w-7 h-7 rounded-full border flex items-center '
        + 'justify-center text-[.95rem] leading-none shrink-0" '
        + 'style="border-color:var(--line);color:var(--ink-soft)">' + zeichen + '</button>';
    };
    return '<div class="flex items-center gap-1.5 shrink-0">'
      + knopf(-1, '&minus;', t('weniger'))
      + '<span class="text-[.85rem] font-700 w-5 text-center">' + menge + '</span>'
      + knopf(1, '+', t('mehr'))
      + '</div>';
  }

  /* Eine Korbzeile. Aufbau und Klassen wie im abgenommenen Prototyp,
     ergaenzt um drei Dinge, die dem Prototyp fehlten und die Michele im
     Shop vermisst hat:
       - Bild und Titel fuehren zur Produktseite (vorher eine Sackgasse)
       - Mengensteller (vorher musste man entfernen und neu waehlen)
       - Entfernen-Link, der auch wirklich entfernt
     Die Beschriftungen folgen der Sprache; das Seitenskript hatte
     "entfernen" fest eingebaut, auch auf Franzoesisch. */
  function zeile(bild, titel, unter, preis, nr, handle, menge) {
    var url = produktLink(handle);
    var bildteil = '<img src="' + bild + '" alt="" class="w-16 h-16 rounded-lg '
                 + 'object-cover shrink-0">';
    var titelteil = '<div class="font-700 text-[.95rem]">' + titel + '</div>';
    if (url) {
      // Bild und Titel fuehren zur Produktseite - vorher war die Zeile im
      // Korb eine Sackgasse: Man sah den Artikel, kam aber nicht mehr hin.
      bildteil = '<a href="' + url + '" class="shrink-0">' + bildteil + '</a>';
      titelteil = '<a href="' + url + '" class="font-700 text-[.95rem] hover:text-blue">'
                + titel + '</a>';
    }
    return '<div class="flex gap-3 py-4 border-b" style="border-color:var(--line)">'
      + bildteil
      + '<div class="flex-1 min-w-0">' + titelteil
      + '<div class="text-[.82rem]" style="color:var(--ink-soft)">' + unter + '</div>'
      + '<div class="mt-2 flex items-center gap-3">'
      + mengensteller(nr, menge)
      + '<button onclick="removeItem(\'' + nr + '\')" class="text-[.78rem] underline '
      + 'shrink-0" style="color:var(--ink-soft)">' + t('entfernen') + '</button>'
      + '<span class="font-700 text-[.92rem] ml-auto text-right" style="color:var(--blue)">'
      + preis + '</span>'
      + '</div></div></div>';
  }

  function zeichnen() {
    zaehlerSetzen();

    var body = document.getElementById('cart-body');
    var foot = document.getElementById('cart-foot');
    if (!body || !korb) return;

    if (!korb.item_count) {
      body.innerHTML = '<div class="text-center py-20" style="color:var(--ink-soft)">'
                     + t('leer') + '</div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    var html = '';
    korb.items.forEach(function (art, i) {
      var bild = art.image || (art.featured_image && art.featured_image.url) || '';
      /* Die Beschriftung haengt am NAMEN der Option, nicht an ihrer
         Position. Vorher galt die erste Option immer als Linie - beim
         Schlafsack, der nur die Groesse fuehrt, stand dadurch
         "Linie 85×224" im Korb. */
      var unter = (art.options_with_values || [])
        .map(function (o) {
          var name = (o.name || '').toLowerCase();
          if (name === 'linie' || name === 'gamme') return t('linie') + o.value;
          if (name === 'grösse' || name === 'groesse' || name === 'taille') {
            return o.value + ' cm';
          }
          return o.value;
        })
        .join(' · ');
      // Die Zeilennummer bei Shopify ist 1-basiert.
      html += zeile(bild, art.product_title, unter,
                    preisText(art.final_line_price), String(i + 1),
                    art.handle, art.quantity);
    });

    html += zusatzverkauf();
    body.innerHTML = html;

    if (foot) {
      foot.style.display = '';
      foot.innerHTML =
        '<div class="flex items-center justify-between mb-4">'
        + '<span class="font-700">' + t('summe') + '</span>'
        + '<span class="serif font-700 text-[1.35rem]" style="color:var(--blue)">'
        + preisText(korb.total_price) + '</span></div>'
        + '<a href="' + wurzel() + '/checkout" class="btn-solid w-full">' + t('kasse') + '</a>'
        + '<button onclick="closeCart()" class="w-full text-center mt-3 text-[.85rem] font-600" '
        + 'style="color:var(--ink-soft)">' + t('weiter') + '</button>';
    }
  }

  /* „Komplettieren Sie Ihr Bett" — nur zeigen, was noch NICHT im Korb liegt.
     Der Prototyp blendet den Block immer ein, auch wenn man das Kissen
     bereits gewählt hat. */
  /* Das Ziel des Querverweises. `z.url` kommt aus der Section und ist
     immer der deutsche Pfad - auf Franzoesisch fuehrte er aus der Sprache
     heraus. Wo es die Seite uebersetzt gibt, wird sie direkt genommen. */
  function zusatzZiel(z) {
    var ueber = produktLink(z.handle);
    if (ueber) return ueber;
    return (String(z.url || '').charAt(0) === '/') ? wurzel() + z.url : z.url;
  }

  function zusatzverkauf() {
    var d = daten();
    if (!d.zusatz || !korb.items.length) return '';

    var linie = KUERZEL[(korb.items[0].options_with_values || [{}])[0].value] || 'comfort';
    var drin = korb.items.map(function (a) { return a.handle; });

    var zeilen = d.zusatz.filter(function (z) { return drin.indexOf(z.handle) < 0; });
    if (!zeilen.length) return '';

    var html = '<div class="mt-5 rounded-2xl p-4" style="background:var(--blue-mist)">'
      + '<div class="text-[.82rem] font-700 mb-3" style="color:var(--blue-deep)">'
      + t('ergaenzen') + '</div>';
    zeilen.forEach(function (z, i) {
      var letzte = i === zeilen.length - 1;
      html += '<div class="flex gap-3 items-center' + (letzte ? '' : ' pb-3 mb-3 border-b')
        + '" style="border-color:rgba(0,102,170,.15)">'
        + '<img src="' + z.bild + '" alt="" class="w-12 h-12 rounded-lg object-cover shrink-0">'
        + '<div class="flex-1 min-w-0"><div class="font-700 text-[.88rem]">'
        + (sprache() === 'fr' && z.titel_fr ? z.titel_fr : z.titel)
        + ' ' + (LINIE[linie] || '') + '</div>'
        + '<div class="text-[.78rem]' + (z.gratis ? ' font-700' : '') + '" style="color:'
        + (z.gratis ? 'var(--blue)' : 'var(--ink-soft)') + '">'
        + (z.gratis ? t('gratis') : t('ab') + z.ab) + '</div></div>'
        + '<a href="' + zusatzZiel(z) + '?linie=' + linie
        + '" class="text-[.8rem] font-700 shrink-0" '
        + 'style="color:var(--blue)">' + t('groesse') + '</a></div>';
    });
    return html + '</div>';
  }

  /* ---------------------------------------------------------------
     Eingriffe in die Seitenfunktionen
     --------------------------------------------------------------- */

  function ersetzen() {
    ['addMatratze', 'addKissen', 'addDecke', 'addReise', 'addSchlafsack'].forEach(function (name) {
      var original = window[name];
      if (typeof original !== 'function' || original.__sg) return;
      var neu = function () {
        var linie = gewaehlteLinie();
        var groesse = gewaehlteGroesse();
        if (!groesse) return;                    // wie im Prototyp

        var v = variante(linie, groesse);
        if (!v) { console.warn('[sg-shop] keine Variante:', linie, groesse); return; }

        var knopf = document.getElementById('addbtn');
        if (knopf) knopf.disabled = true;
        fetchJSON(wurzel() + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        })
          .then(korbLesen)
          .then(function () { zeichnen(); if (window.openCart) window.openCart(); })
          .catch(function (e) {
            console.error('[sg-shop] Warenkorb:', e);
            alert(t('fehler'));
          })
          .finally(function () { if (knopf) knopf.disabled = false; });
      };
      neu.__sg = true;
      window[name] = neu;
    });

  }

  /* Bedienung des Korbs. Steht BEWUSST ausserhalb von ersetzen():
     Dort landete removeItem zuerst, und ersetzen() laeuft nur auf
     Produktseiten. Auf allen anderen 18 Seiten war `removeItem` damit
     nicht definiert - der Entfernen-Knopf tat schlicht nichts, genau wie
     Michele es gemeldet hat. Der Korb ist auf JEDER Seite bedienbar, also
     gehoert seine Bedienung auch auf jede Seite. */
  function korbBedienung() {
    window.renderCart = function () { korbLesen().then(zeichnen); };
    window.renderCart.__sg = true;

    function aendern(zeile, menge) {
      return fetchJSON(wurzel() + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(zeile), quantity: Math.max(0, Number(menge)) })
      })
        .then(function (k) { korb = k; zeichnen(); })
        .catch(function (e) { console.error('[sg-shop] Korb:', e); });
    }

    window.removeItem = function (zeile) { return aendern(zeile, 0); };
    window.removeItem.__sg = true;

    /* Menge aendern. Der Prototyp kannte keine Mengensteuerung - im Shop
       braucht es sie, sonst muss man den Artikel entfernen und neu
       auswaehlen, um zwei Stueck zu bestellen. */
    window.sgMenge = function (zeile, richtung) {
      if (!korb || !korb.items) return;
      var art = korb.items[Number(zeile) - 1];
      if (!art) return;
      return aendern(zeile, art.quantity + Number(richtung));
    };
  }

  function kasseVerdrahten() {
    document.querySelectorAll('a, button').forEach(function (el) {
      if (el.__sg || !/Zur Kasse|caisse/i.test((el.textContent || '').trim())) return;
      el.__sg = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = wurzel() + '/checkout';
      });
    });
  }


  /* ---- Sticky-Kaufleiste (Mobil) ------------------------------------
     Hier wird NUR gemeldet, ob der grosse Kaufknopf aus dem Bild ist -
     sichtbar macht die Leiste allein das CSS.

     Warum diese Aufteilung: Der erste Versuch setzte transform direkt am
     Element. Inline-Stile schlagen aber jede CSS-Regel, und damit hat das
     Skript die Regel ueberstimmt, die die Leiste bei offenem Warenkorb
     oder Menue ausblenden soll. Michele sah die Leiste deshalb weiterhin
     ueber dem Menue. Eine Klasse kollidiert mit nichts. */
  function stickyLeiste() {
    var leiste = document.querySelector('.sg-stickybuy');
    if (!leiste) return;

    /* Bezugspunkt: auf Produktseiten der grosse Kaufknopf, auf den
       Kategorieseiten deren erster eigener Handlungsknopf. Letztere haben
       keinen #addbtn - ohne diesen Rueckfall blieb die Leiste dort ohne
       Bezug und erschien sofort im Kopfbereich, ueber dem Knopf, den sie
       eigentlich ersetzen soll. */
    var haupt = document.getElementById('addbtn');
    if (!haupt) {
      var kandidaten = document.querySelectorAll('a.btn-solid, button.btn-solid');
      for (var i = 0; i < kandidaten.length; i++) {
        if (!kandidaten[i].classList.contains('sg-stickybuy')) {
          haupt = kandidaten[i];
          break;
        }
      }
    }
    if (!haupt) return;

    function pruefen() {
      var vorbei = false;
      if (haupt) {
        /* NUR nach oben hinausgescrollt zaehlt. Der erste Versuch fragte
           "ausserhalb des Bildes" - auf dem Handy liegt der Kaufknopf aber
           UNTER der Galerie und ist ganz oben deshalb ebenfalls draussen.
           Die Leiste erschien dadurch sofort im Kopfbereich, obwohl man
           den Knopf noch gar nicht gesehen hatte. */
        vorbei = haupt.getBoundingClientRect().bottom < 0;
      }
      document.body.classList.toggle('sg-kauf-vorbei', vorbei);
    }

    pruefen();
    window.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen);
  }

  function start() {
    /* Korb lesen und anzeigen passiert IMMER - auf jeder Seite.
       Vorher stieg diese Funktion sofort aus, wenn die Seite keine Varianten
       lieferte. Varianten liefern aber nur die vier Produktseiten. Auf allen
       anderen 18 Seiten lief das Skript darum gar nicht: Der Zaehler blieb
       leer, obwohl Ware im Korb lag, und die Schublade blieb ungefuellt.
       Varianten braucht nur das Hinzufuegen - sonst nichts. */
    korbBedienung();
    kasseVerdrahten();
    stickyLeiste();
    korbLesen().then(zeichnen).catch(function () {});

    if (!Object.keys(eintraege()).length) return;   // keine Produktseite
    ersetzen();
  }

  if (document.readyState === 'complete') setTimeout(start, 0);
  else window.addEventListener('load', function () { setTimeout(start, 0); });
})();
